import save from '../Services/save'

export default () => (dispatch) => {
  
  dispatch(save())
  
}
